"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedCookbook = void 0;
const client_1 = require("@apollo/client");
const cookbook_1 = require("../fragments/cookbook");
exports.getSharedCookbook = client_1.gql `
  query GetSharedCookbook($shareId: String!) {
    getSharedCookbook(shareId: $shareId) {
      ...justCookbook
      byName
      accessLevel
    }
  }

  ${cookbook_1.justCookbookFragment}
`;
//# sourceMappingURL=getSharedCookbook.js.map